import { createContext, useContext } from 'react';
import { AlertBannerContextType } from './types';

const AlertBannerContext = createContext({} as AlertBannerContextType);

export { AlertBannerContext };
export const useAlertBanner = () => useContext(AlertBannerContext);
